import React, { useState } from 'react';
import { RejectDialog, RejectDialogProps } from '@/components/dialogs';
import { rejectExternalAgreement } from '@/services/external-agreements';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Trans } from '@lingui/react/macro';
import { ExternalAgreement } from '@/types';

interface ExternalAgreementRejectDialogProps
    extends Omit<RejectDialogProps, 'title' | 'dialogName' | 'uploadedByName' | 'sendRejectEmail' | 'onSendRejectChange'> {
    externalAgreement: ExternalAgreement;
}

const ExternalAgreementRejectDialog: React.FC<ExternalAgreementRejectDialogProps> = ({
    onReject,
    externalAgreement,
    ...rest
}) => {
    const [sendRejectEmail, setSendRejectEmail] = useState(false);
    const handleReject = async (reason: string) => {
        var promise = await rejectExternalAgreement(externalAgreement.id, reason, sendRejectEmail);
        triggerHandler(onReject, reason);
        return promise;
    };

    return (
        <RejectDialog
            title={<Trans>Reject external agreement</Trans>}
            onReject={handleReject}
            dialogName="reject-external-agreement"
            sendRejectEmail={sendRejectEmail}
            onSendRejectChange={(v) => setSendRejectEmail(v)}
            sendRejectEmailLabel={
                <Trans>
                    Send email notifying "{externalAgreement.createdByUser.name}" about rejecting this external agreement.
                </Trans>
            }
            {...rest}
        />
    );
};

export default ExternalAgreementRejectDialog;
